// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__3AGCn","bigColWidth":"Table_bigColWidth__3vod7","biggerColWidth":"Table_biggerColWidth__3aD72","row":"Table_row__1PvR5","col":"Table_col__1gIn7"};